import { motion } from "framer-motion";
import React, { useState } from "react";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import Text from "./Text";
const Chat: React.FC = () => {
  const [activeChat, setActiveChat] = useState(1);

  const toggleActiveChat = (num: number) => {
    if (activeChat !== num) setActiveChat(num);
  };

  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
      style={{ position: "relative" }}
    >
      {/* <TogglerContainer>
        <ActiveToggle
          onClick={() => toggleActiveChat(1)}
          active={activeChat === 1 && true}
        >
          Chat
        </ActiveToggle>
        <ActiveToggle
          onClick={() => toggleActiveChat(2)}
          active={activeChat === 2 && true}
        >
          Community
        </ActiveToggle>
      </TogglerContainer> */}
      <Text />
    </motion.div>
  );
};
export default Chat;
